/* ==========================================================================
   Helpers > Array
   ========================================================================== */

/**
 * Group By
 * Groups a collection of objects based on key
 * @param {array} Collection
 * @param {function} Key getter
 * @returns {array} Collection grouped by key
 */
function groupBy(list, fn) {
    const map = new Map();
    list.forEach(item => {
        const key = fn(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });

    return map;
}

/**
 * Sort by key value
 * Sorts an array of objects by the given key name
 * @param {array} Collection
 * @param {string} Key value
 * @returns {array} Collection ordered by the key value
 */
function sortByKey(collection = [], key = '') {
    if (!key) return collection.slice();

    return collection.sort((a, b) => (a[key] > b[key] ? -1 : 1));
}

/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param {array} superset
 * @param {array} subset
 *
 * @returns {boolean}
 */
function containsArray(superset = [], subset = []) {
    if (subset.length === 0) {
        return false;
    }
    return subset.every(value => superset.indexOf(value) >= 0);
}

/* Exports */
module.exports = {
    groupBy,
    sortByKey,
    containsArray
};
